import routerUtility from 'utils/routerUtility';
import { customModuleRouteHelper, CustomModuleRouteHelper } from './helpers/routeHelper';
import { get, isEmpty } from 'lodash';
import AppError from 'utils/appError';
import moduleStore from 'store/moduleStore';
import RouterRedirect from 'utils/RouterRedirect';
import modulePaths from 'constants/modulePath';

export default {

  path: CustomModuleRouteHelper.ROOT_PATH,

  getComponent(nextState, callback) {
    const query = get(nextState, 'location.query');

    // perform base access check first
    let error = routerUtility.getAccessError(customModuleRouteHelper.getModuleCodeFromQuery(query));
    if (error) {
      callback(error);
      return;
    }

    // if there is no base error, first process the case when custom module code is not specified in the query string
    if (isEmpty(query)) {
      const currentModule = moduleStore.getCurrentModule();
      if (currentModule.isCustom) {
        // redirect to the currently saved active module
        error = new RouterRedirect(modulePaths.createCustomModulePath(currentModule.code));
        callback(error);
        return;
      }
    }

    // if the query string is not empty but its custom module code is invalid, redirect to 'access denied'
    if (!customModuleRouteHelper.isValidModulePath(query)) {
      error = new AppError(AppError.CODE_ACCESS_DENIDED);
      callback(error);
      return;
    }

    import(/* webpackChunkName: "custom-module-layout" */ './layouts/moduleLayout').then(
      (layoutContainer) => callback(null, layoutContainer.default)
    );
  },

  getIndexRoute(partialNextState, callback) {
    require.ensure([], function (require) {
      callback(null, {
        component: require('./views/homePage').HomePage,
      }, 'custom-module')
    })
  }

};
